import type { TournamentStatus } from 'types/interfaces/play';

/** Shared display helpers for Play screens (dates, clocks, status labels). */

export const formatStartLine = (iso: string, timeZone?: string): string => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return 'Date TBD';
  try {
    const date = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone });
    const time = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone });
    return `${date} · ${time}`;
  } catch {
    return d.toLocaleString();
  }
};

/** MM:SS; negative seconds render with a leading + (overtime after Time called). */
export const formatClock = (seconds: number): string => {
  const s = Math.abs(Math.trunc(seconds));
  const mm = String(Math.floor(s / 60)).padStart(2, '0');
  const ss = String(s % 60).padStart(2, '0');
  return `${seconds < 0 ? '+' : ''}${mm}:${ss}`;
};

export const tournamentStatusLabel = (status: TournamentStatus, currentRound: number | null, totalRounds: number): string => {
  switch (status) {
    case 'LOBBY':
      return 'Registration open';
    case 'PAIRED':
      return currentRound ? `Round ${currentRound} paired` : 'Paired';
    case 'LIVE':
      return currentRound ? `Round ${currentRound} of ${totalRounds} · Live` : 'Live';
    case 'COMPLETE':
      return 'Complete';
    default:
      return status;
  }
};

export const ordinal = (n: number): string => {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`;
};

export const percent = (ratio: number): string => `${Math.round(ratio * 100)}%`;

export const recordLabel = (wins: number, losses: number, draws: number): string => `${wins}-${losses}-${draws}`;
